import { useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTour } from '@/contexts/Tour.context';
import { appRoutes } from '@/routes';
import { tourRegistry } from '@/tours';

/**
 * Path-based tour trigger: /tour/:tourName?callback=<encoded-url>
 * Starts the named tour and navigates to its first step's path.
 */
export const TourStartRoute = () => {
  const { tourName } = useParams();
  const { startTour, setCallbackUrl } = useTour();
  const history = useHistory();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;

    if (!tourName || !tourRegistry[tourName]) {
      history.replace(appRoutes().teamDashboard);
      return;
    }

    firedRef.current = true;

    // Read window.location.search directly — avoids a connected-react-router
    // timing issue where useLocation().search may not yet reflect the URL.
    const params = new URLSearchParams(window.location.search);
    const callback = params.get('callback');
    if (callback) {
      setCallbackUrl(decodeURIComponent(callback));
    }

    // Always (re)start — visiting /tour/:tourName is an explicit request to
    // run that tour now, even if a different (or stale) one was active.
    const steps = tourRegistry[tourName];
    const firstPath = steps[0]?.path || appRoutes().teamDashboard;

    startTour(tourName);
    history.replace(firstPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
